// extracted by mini-css-extract-plugin
module.exports = {"main":"Notifications_main__3wqdX","box":"Notifications_box__1oha8"};